var ValidationViewController = (function () {
    function ValidationViewController($state, settings, env, socket, $scope, Dialog, admin) {
        var _this = this;
        this.$state = $state;
        this.settings = settings;
        this.env = env;
        this.socket = socket;
        this.$scope = $scope;
        this.Dialog = Dialog;
        this.admin = admin;
        this.isSaving = false;
        this.docTableOrig = {};
        this.docTable = [];
        this.countryTable = [];
        this.isDivisionLoaded = false;
        this.isCountryLoaded = false;
        this.newCode = {
            isLineValid: true
        };
        this.socket.forward('validationview.ctyList', this.$scope);
        this.$scope.$on('socket:validationview.ctyList', function (event, data) {
            _this.countryTable = data;
            _this.isCountryLoaded = true;
        });
        this.socket.forward('validationview.valTables', this.$scope);
        this.$scope.$on('socket:validationview.valTables', function (event, data) {
            for (var i = 0; i < data.tbl.length; i++) {
                data.tbl[i].isValid = true;
                for (var i2 = 0; i2 < data.tbl[i].currentTable.length; i2++) {
                    data.tbl[i].currentTable[i2].isLineValid = true;
                    data.tbl[i].currentTable[i2].reqStart = new Date(data.tbl[i].currentTable[i2].reqStart);
                    data.tbl[i].currentTable[i2].reqEnd = new Date(data.tbl[i].currentTable[i2].reqEnd);
                }
                data.tbl[i].origTable = JSON.parse(JSON.stringify(data.tbl[i].currentTable));
            }
            if (typeof _this.curTab === 'undefined') {
                _this.curTab = data.tbl[0];
            }
            for (var i2 = 0; i2 < _this.curTab.colNames.length; i2++) {
                _this.newCode[_this.curTab.colNames[i2].colKey] = '';
            }
            _this.docTable = data;
            _this.docTableOrig = JSON.parse(JSON.stringify(data));
            _this.isDivisionLoaded = true;
            if (_this.isSaving) {
                //Once done saving, send email to Admin team
                var emailBundle = { docurl: 'validation-view', profile: 'Validation Rule Table (' + _this.curTab.name + ')', user: _this.env.user };
                _this.admin.sendAdminUpdate(emailBundle);
            }
            _this.isSaving = false;
        });
    }
    ValidationViewController.prototype.$onInit = function () {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getValidationListBackend',
                script: 'validation/validationTables',
                email: this.env.user.email,
                token: this.env.user.token
            }
        });
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'getCountryList',
                script: 'validation/validationTables',
                email: this.env.user.email,
                token: this.env.user.token
            }
        });
    };
    // all tables need to have reqStart and reqEnd to describe their validity period
    // tables either have to have a reqCode property when only one property is essentail for comparison
    // or a series of combo keys when a combination of properties distinguishes entries
    ValidationViewController.prototype.addNewCode = function (oneTab) {
        var addLine = {};
        var addText = '';
        for (var key in this.newCode) {
            for (var i = 0; i < oneTab.colNames.length; i++) {
                if (key === oneTab.colNames[i].colKey) {
                    addLine[key] = this.newCode[key];
                    if (key !== 'reqStart' && key !== 'reqEnd') {
                        if (addText === '') {
                            addText = this.newCode[key];
                        }
                        else {
                            addText = addText + ', ' + this.newCode[key];
                        }
                    }
                }
            }
        }
        addLine.reqStart = new Date(addLine.reqStart);
        addLine.reqEnd = new Date(addLine.reqEnd);
        var startText = addLine.reqStart.getDate() + '.' + (addLine.reqStart.getMonth() + 1) + '.' + addLine.reqStart.getFullYear();
        var endText = addLine.reqEnd.getDate() + '.' + (addLine.reqEnd.getMonth() + 1) + '.' + addLine.reqEnd.getFullYear();
        var historyGen = ['Entry created: ' + addText + ', ' + startText + ', ' + endText];
        var timeStamp = new Date();
        var timeText = timeStamp.getDate() + '.' + (timeStamp.getMonth() + 1) + '.' + timeStamp.getFullYear();
        var oneHist = {
            timestamp: timeText,
            comment: historyGen,
            user: this.env.user.email
        };
        oneTab.tableHistory.push(oneHist);
        oneTab.currentTable.push(addLine);
        this.voidNew(oneTab);
        this.checkValidity(oneTab);
        this.docTableOrig = JSON.parse(JSON.stringify(this.docTable));
        for (var i = 0; i < this.docTable.tbl.length; i++) {
            delete this.docTableOrig.tbl[i].origTable;
            this.docTable.tbl[i].origTable = JSON.parse(JSON.stringify(this.docTable.tbl[i].currentTable));
        }
        this.isSaving = true;
        this.sendforUpdate(historyGen);
    };
    ValidationViewController.prototype.voidNew = function (oneTab) {
        console.info(oneTab.name);
        this.curTab = oneTab;
        this.newCode = {
            isLineValid: true
        };
        for (var i2 = 0; i2 < oneTab.colNames.length; i2++) {
            this.newCode[oneTab.colNames[i2].colKey] = '';
        }
    };
    // all tables need to have reqStart and reqEnd to describe their validity period
    // tables either have to have a reqCode property when only one property is essentail for comparison
    // or a series of combo keys when a combination of properties distinguishes entries
    ValidationViewController.prototype.checkValidity = function (oneTab) {
        oneTab.isValid = true;
        for (var i = 0; i < oneTab.currentTable.length; i++) {
            oneTab.currentTable[i].isLineValid = true;
        }
        for (var i = 0; i < oneTab.currentTable.length - 1; i++) {
            if (!(oneTab.currentTable[i].reqStart instanceof Date) || !(oneTab.currentTable[i].reqEnd instanceof Date)) {
                oneTab.currentTable[i].isLineValid = false;
                oneTab.isValid = false;
            }
            else if (oneTab.currentTable[i].reqStart > oneTab.currentTable[i].reqEnd) {
                oneTab.currentTable[i].isLineValid = false;
                oneTab.isValid = false;
            }
            else {
                for (var i2 = i + 1; i2 < oneTab.currentTable.length; i2++) {
                    var perfectFit = true;
                    var checkFit = false;
                    for (var key in oneTab.currentTable[i]) {
                        if (key.search('combo') > -1) {
                            checkFit = true;
                            if (oneTab.currentTable[i][key] !== oneTab.currentTable[i2][key]) {
                                perfectFit = false;
                                break;
                            }
                        }
                    }
                    if ((oneTab.currentTable[i].reqCode === oneTab.currentTable[i2].reqCode && typeof oneTab.currentTable[i].reqCode !== 'undefined')
                        || (oneTab.currentTable[i].country === oneTab.currentTable[i2].country && typeof oneTab.currentTable[i].country !== 'undefined')
                        || (perfectFit && checkFit)) {
                        if ((oneTab.currentTable[i].reqStart < oneTab.currentTable[i2].reqStart && oneTab.currentTable[i2].reqStart < oneTab.currentTable[i].reqEnd)
                            || (oneTab.currentTable[i].reqStart < oneTab.currentTable[i2].reqEnd && oneTab.currentTable[i2].reqEnd < oneTab.currentTable[i].reqEnd)
                            || (oneTab.currentTable[i].reqStart >= oneTab.currentTable[i2].reqStart && oneTab.currentTable[i2].reqEnd >= oneTab.currentTable[i].reqEnd)) {
                            oneTab.currentTable[i].isLineValid = false;
                            oneTab.currentTable[i2].isLineValid = false;
                            oneTab.isValid = false;
                        }
                    }
                }
            }
        }
        this.newCode.isLineValid = true;
        if ((this.newCode.reqStart > this.newCode.reqEnd)) {
            this.newCode.isLineValid = false;
        }
        else if (oneTab.currentTable.length > 0) {
            for (var i2 = 0; i2 < oneTab.currentTable.length; i2++) {
                var perfectFit = true;
                var checkFit = false;
                for (var key in this.newCode) {
                    if (key.search('combo') > -1) {
                        checkFit = true;
                        if (this.newCode[key] !== oneTab.currentTable[i2][key]) {
                            perfectFit = false;
                            break;
                        }
                    }
                }
                if ((this.newCode.reqCode === oneTab.currentTable[i2].reqCode && typeof this.newCode.reqCode !== 'undefined') || (perfectFit && checkFit)) {
                    if ((this.newCode.reqStart < oneTab.currentTable[i2].reqStart && oneTab.currentTable[i2].reqStart < this.newCode.reqEnd)
                        || (this.newCode.reqStart < oneTab.currentTable[i2].reqEnd && oneTab.currentTable[i2].reqEnd < this.newCode.reqEnd)
                        || (this.newCode.reqStart >= oneTab.currentTable[i2].reqStart && oneTab.currentTable[i2].reqEnd >= this.newCode.reqEnd)) {
                        this.newCode.isLineValid = false;
                        oneTab.currentTable[i2].isLineValid = false;
                        oneTab.isValid = false;
                    }
                }
            }
        }
    };
    ValidationViewController.prototype.deleteConfirmation = function (ev, oneTab, oneItem) {
        var _this = this;
        this.Dialog.confirmDelete(ev, oneTab).then(function (dResult) {
            //        this.Dialog.updateValidForm(event, this.toDelete, 'sampling.html').then((dResult: any) => {
            if (dResult) {
                _this.deleteLine(oneTab, oneItem);
            }
        });
    };
    ValidationViewController.prototype.deleteLine = function (oneTab, oneItem) {
        var curPosItem = oneTab.currentTable.indexOf(oneItem);
        var curPosTab = this.docTable.tbl.indexOf(oneTab);
        var startDate = new Date(this.docTable.tbl[curPosTab].origTable[curPosItem].reqStart);
        var startText = startDate.getDate() + '.' + (startDate.getMonth() + 1) + '.' + startDate.getFullYear();
        var endDate = new Date(this.docTable.tbl[curPosTab].currentTable[curPosItem].reqEnd);
        var endText = endDate.getDate() + '.' + (endDate.getMonth() + 1) + '.' + endDate.getFullYear();
        var timeStamp = new Date();
        var timeText = timeStamp.getDate() + '.' + (timeStamp.getMonth() + 1) + '.' + timeStamp.getFullYear();
        var comment = 'Deleted: ';
        for (var key in this.docTable.tbl[curPosTab].currentTable[curPosItem]) {
            if (key !== 'reqStart' && key !== 'reqEnd' && key !== 'isLineValid') {
                comment += this.docTable.tbl[curPosTab].currentTable[curPosItem][key] + ', ';
            }
        }
        var oneHist = {
            timestamp: timeText,
            comment: [comment + ', start ' + startText + ', end ' + endText],
            user: this.env.user.email
        };
        this.docTable.tbl[curPosTab].tableHistory.push(oneHist);
        this.docTable.tbl[curPosTab].currentTable.splice(curPosItem, 1);
        this.docTableOrig = JSON.parse(JSON.stringify(this.docTable));
        for (var i = 0; i < this.docTable.tbl.length; i++) {
            delete this.docTableOrig.tbl[i].origTable;
            this.docTable.tbl[i].origTable = JSON.parse(JSON.stringify(this.docTable.tbl[i].currentTable));
        }
        this.isSaving = true;
        this.sendforUpdate(oneHist.comment);
    };
    ValidationViewController.prototype.save = function (oneTab) {
        var curPos = this.docTable.tbl.indexOf(oneTab);
        var historyGen = [];
        var commentBase = [];
        if (typeof this.docTable.tbl[curPos].origTable[0].reqCode === 'undefined') {
            for (var key in this.docTable.tbl[curPos].origTable[0]) {
                if (key.search('combo') > -1) {
                    commentBase.push(key);
                }
            }
        }
        else {
            commentBase.push(this.docTable.tbl[curPos].origTable[0].reqCode);
        }
        for (var i2 = 0; i2 < this.docTable.tbl[curPos].currentTable.length; i2++) {
            for (var key in this.docTable.tbl[curPos].currentTable[i2]) {
                if (key === '$$hashKey') {
                    delete this.docTable.tbl[curPos].currentTable[i2][key];
                }
                else if (this.docTable.tbl[curPos].origTable[i2][key] !== this.docTable.tbl[curPos].currentTable[i2][key]) {
                    var colName = '';
                    var isDate = false;
                    if (key === 'reqStart' || key === 'reqEnd') {
                        isDate = true;
                    }
                    var mainText = '';
                    for (var iBase = 0; iBase < commentBase.length; iBase++) {
                        if (iBase === 0) {
                            mainText = this.docTable.tbl[curPos].origTable[i2][commentBase[iBase]];
                        }
                        else {
                            mainText = mainText + ', ' + this.docTable.tbl[curPos].origTable[i2][commentBase[iBase]];
                        }
                    }
                    if (!isDate) {
                        historyGen.push(mainText + ', ' + colName + ' changed from ' + this.docTable.tbl[curPos].origTable[i2][key] + ' to ' + this.docTable.tbl[curPos].currentTable[i2][key]);
                    }
                    else {
                        var orDate = new Date(this.docTable.tbl[curPos].origTable[i2][key]);
                        var orText = orDate.getDate() + '.' + (orDate.getMonth() + 1) + '.' + orDate.getFullYear();
                        var curDate = new Date(this.docTable.tbl[curPos].currentTable[i2][key]);
                        var curText = curDate.getDate() + '.' + (curDate.getMonth() + 1) + '.' + curDate.getFullYear();
                        if (orText !== curText) {
                            historyGen.push(mainText + ', ' + colName + ' changed from ' + orText + ' to ' + curText);
                        }
                    }
                }
            }
        }
        if (historyGen.length > 0) {
            var timeStamp = new Date();
            var timeText = timeStamp.getDate() + '.' + (timeStamp.getMonth() + 1) + '.' + timeStamp.getFullYear();
            var oneHist = {
                timestamp: timeText,
                comment: historyGen,
                user: this.env.user.email
            };
            this.docTable.tbl[curPos].tableHistory.push(oneHist);
            this.docTableOrig = JSON.parse(JSON.stringify(this.docTable));
            for (var i = 0; i < this.docTable.tbl.length; i++) {
                delete this.docTableOrig.tbl[i].origTable;
                this.docTable.tbl[i].origTable = JSON.parse(JSON.stringify(this.docTable.tbl[i].currentTable));
            }
            this.isSaving = true;
            this.sendforUpdate(historyGen);
        }
    };
    ValidationViewController.prototype.sendforUpdate = function (historyText) {
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'sendValidationListBackend',
                script: 'validation/validationTables',
                email: this.env.user.email,
                token: this.env.user.token,
                data: this.docTableOrig,
                receivers: ['roman.tibensky@sk.ibm.com'],
                historyText: historyText
            }
        });
    };
    ValidationViewController.$inject = ['$state', 'settings', 'env', 'socket', '$scope', 'Dialog', 'admin'];
    return ValidationViewController;
}());
var ValidationViewComponent = (function () {
    function ValidationViewComponent() {
        this.templateUrl = 'validation-view.html';
        this.controllerAs = 'vm';
        this.controller = ValidationViewController;
    }
    return ValidationViewComponent;
}());
angular
    .module('application')
    .config(function ($mdIconProvider) {
    $mdIconProvider
        .icon('delete', '/public/icons/delete-forever.svg')
        .icon('invalid', '/public/icons/ic_highlight_off_black_24px.svg')
        .icon('save', '/public/images/ic_save_black_24px.svg');
})
    .component('viewValidationSection', new ValidationViewComponent());

//# sourceMappingURL=validation.view.component.js.map
